var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuralwardLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.2 186.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee2a7b",
    d: "M105,34.34L87.17.26l39.56,11.54c10.12,3.58,19.86,7.37,29.47,12.05l-.07,72.15c0,7.12-1.51,13.6-3.75,20.17-5.67,16.62-17.74,31.38-31.08,42.16-.51-.17-.77-.54-1.12-1.15l-18.15-31.56-37.79-66.8-8.88-15.51-5.13-8.97s-12.82,4.04-22.23,7l.23,55.41c.03,6.6,2.9,12.91,6.04,18.45,5.16,9.09,12.6,15.57,21.02,21.58l.06-46.34,13.61,23.31,33.98,58.04-24.48,14.99-17.65-10.69-7.52-4.77c-19.14-12.38-39.71-30.35-47.84-52.29C2.46,110.97.21,102.87.19,94.12l-.19-69.9,10.1-4.62c10.35-4.73,20.98-7.92,31.88-11.27L69.12,0l5.79,10.61,15.61,28.1,1.23,2.2,29.75,53.76,7.12,13.29.05-66.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuralwardLogoSm);
export default __webpack_public_path__ + "static/media/neuralward-logo-sm.5bbbed4644507afc40508cfccee3b808.svg";
export { ForwardRef as ReactComponent };